import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isBrowseOpen, setIsBrowseOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleBrowse = () => {
    setIsBrowseOpen(!isBrowseOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? "bg-white shadow-md" : "bg-transparent"
        }`}
    >
      <header className="flex justify-between items-center px-6 md:px-10 lg:px-20 py-5">
        {/* Logo Section */}
        <div className="flex items-center space-x-2">
          <img
            src={`${isScrolled ? "logob.webp" : "logo.png"}`}
            alt="Applicationuni Logo"
            className="h-6 lg:h-6 md:h-8"
          />
          <Link to="/">
            <h1
              className={`${isScrolled ? "text-blue-800" : "text-white"
                } text-sm md:text-md lg:text-lg font-bold`}
              onClick={scrollToTop}
            >
              ApplicationUni
            </h1>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav
          className={`hidden md:flex space-x-6 font-bold text-sm md:text-md ${isScrolled ? "text-blue-600" : "text-white"
            }`}
        >
          <div className="relative group hidden sm:block">
            <button className="hover:underline hover:underline-offset-8">
              Browse Programs
            </button>
            <div className="absolute hidden group-hover:block bg-white shadow-lg border mt-2 z-10 w-[900px] left-[-100px] right-[-100px]">
              <div className="grid w-[700px] gap-3 p-6">
                <div className="grid grid-cols-4 gap-6">
                  <div>
                    <h3 className="text-lg font-semibold text-blue-500 mb-3">Popular Tours</h3>
                    <div className="grid gap-2">
                      {[
                        { name: "UN NASA Tour", pdf: "/pdfs/NASA.pdf" },
                        { name: "United Nation Tour", pdf: "/pdfs/UN.pdf" },
                        { name: "Australia Tour", pdf: "/pdfs/Sydney.pdf" },
                        { name: "London Tour", pdf: "/pdfs/London.pdf" },
                        { name: "Canada Tour", pdf: "/pdfs/Canada.pdf" },
                      ].map((item, index) => (
                        <Link
                          key={index}
                          to={item.pdf}
                          className="text-sm text-black hover:text-blue-500"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>


                  <div>
                    <h3 className="text-lg font-semibold text-blue-500 mb-3">Science Tours</h3>
                    <div className="grid gap-2">
                      {[
                        { name: "UN NASA Tour", pdf: "/pdfs/NASA.pdf" },
                        { name: "London Tour", pdf: "/pdfs/London.pdf" },
                        { name: "Japan Tour", pdf: "/pdfs/Japan_Trip.pdf" },
                      ].map((item, index) => (
                        <Link
                          key={index}
                          to={item.pdf}
                          className="text-sm text-black hover:text-blue-500"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>


                  <div>
                    <h3 className="text-lg font-semibold text-blue-500 mb-3">Art & Design</h3>
                    <div className="grid gap-2">
                      {[
                        { name: "UN NASA Tour", pdf: "/pdfs/NASA.pdf" },
                        { name: "Silicon Valley Tour", pdf: "/pdfs/Silicon Valley.pdf" },
                        { name: "Singapore Tour", pdf: "/pdfs/Singapore.pdf" },
                      ].map((item, index) => (
                        <Link
                          key={index}
                          to={item.pdf}
                          className="text-sm text-black hover:text-blue-500"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>


                  <div>
                    <h3 className="text-lg font-semibold text-blue-500 mb-3">Other</h3>
                    <div className="grid gap-2">
                      {[
                        { name: "South Korean Tour", pdf: "/pdfs/South Korea.pdf" },
                        { name: "Spain Tour", pdf: "/pdfs/Spain.pdf" },
                        { name: "Dubai", pdf: "/pdfs/Dubai.pdf" },
                        { name: "China", pdf: "/pdfs/China.pdf" },
                      ].map((item, index) => (
                        <Link
                          key={index}
                          to={item.pdf}
                          className="text-sm text-black hover:text-blue-500"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>

                  {/* Add other sections like Popular Destinations, By Interest, etc. */}
                </div>
              </div>
            </div>
          </div>

          <Link to="/destination" className="hover:underline hover:underline-offset-8" onClick={scrollToTop}>
            Educaional Tours
          </Link>
          <Link to="/aboutus" className="hover:underline hover:underline-offset-8" onClick={scrollToTop}>
            About Us
          </Link>
          <Link to="/programs" className="hover:underline hover:underline-offset-8" onClick={scrollToTop}>
            Study Abroad
          </Link>
          <Link to="/contact" className="hover:underline hover:underline-offset-8" onClick={scrollToTop}>
            Contact Us
          </Link>
        </nav>

        {/* Mobile Hamburger Menu Icon */}
        <button
          onClick={toggleMenu}
          className={`md:hidden flex items-center justify-center w-10 h-10 ${isScrolled ? "text-blue-800" : "text-white"
            }`}
          aria-label="Toggle menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </header>

      {/* Mobile Navigation Dropdown */}
      {isMenuOpen && (
        <nav className="md:hidden bg-white border-t border-gray-200">
          <ul className="flex flex-col items-center space-y-4 py-4">
           
            <li>
              <Link
                to="/destination"
                className="hover:underline hover:underline-offset-8"
                onClick={() => {
                  toggleMenu();
                  scrollToTop();
                }}
              >
                Educational Tours
              </Link>
            </li>
            <li>
              <Link
                to="/programs"
                className="hover:underline hover:underline-offset-8"
                onClick={() => {
                  toggleMenu();
                  scrollToTop();
                }}
              >
                Study Abroad
              </Link>
            </li>
            <li>
              <Link
                to="/aboutus"
                className="hover:underline hover:underline-offset-8"
                onClick={() => {
                  toggleMenu();
                  scrollToTop();
                }}
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:underline hover:underline-offset-8"
                onClick={() => {
                  toggleMenu();
                  scrollToTop();
                }}
              >
                Contact Us
              </Link>
            </li>
            {/* Add other links */}
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Navbar;
